/* global shaka */
var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Shaka = youbora.Adapter.extend({

  constructor: function (player) {
    youbora.adapters.Shaka.__super__.constructor.call(this, player)
    this.tag = this.player.getMediaElement ? this.player.getMediaElement() : this.player.a
  },

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.tag.currentTime
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return this.player.getPlaybackRate() || 1
  },

  /** Override to return Frames Per Secon (FPS) */
  getFramesPerSecond: function () {
    var track = this._getActiveTrack()
    return track ? track.frameRate : null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.player.getStats().droppedFrames
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.tag.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var stats = this.player.getStats()
    var ret = null
    if (typeof stats.streamBandwidth !== 'undefined') {
      ret = stats.streamBandwidth
    }
    if (typeof stats.streamStats !== 'undefined') {
      ret = stats.streamStats.videoBandwidth
    }
    return ret
  },

  /** Override to return rendition */
  getRendition: function () {
    var track = this._getActiveTrack()
    return track ? youbora.Util.buildRenditionString(track.width, track.height, track.bandwidth) : null
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    return this.player.getStats().estimatedBandwidth
  },

  /** Override to return title */
  getTitle: function () {
    return this.tag.title
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.isLive() ? true : !this.getDuration()
  },

  /** Override to return resource URL. */
  getResource: function () {
    var ret = this.tag.currentSrc
    if (this.player.getAssetUri && this.player.getAssetUri()) {
      ret = this.player.getAssetUri()
    } else if (this.player.getManifestUri && this.player.getManifestUri()) {
      ret = this.player.getManifestUri()
    }
    return ret
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    var ret = null
    if (shaka.Player) {
      ret = shaka.Player.version
    } if (shaka.player) {
      ret = shaka.player.Player.version
    }
    return ret
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Shaka'
  },

  /** Get the active track, to get playrate, rendition... */
  _getActiveTrack: function () {
    var ret = null
    if (this.player.getVariantTracks) {
      var tracks = this.player.getVariantTracks()
      for (var i in tracks) {
        var track = tracks[i]
        if (track.active && (track.type === 'video' || track.type === 'variant')) {
          ret = track
        }
      }
    } else if (this.player.getVideoTracks) {
      var tracks2 = this.player.getVideoTracks()
      for (var j in tracks2) {
        var track2 = tracks2[j]
        if (track2.active) {
          ret = track2
        }
      }
    }
    return ret
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    // youbora.Util.logAllEvents(this.tag)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)

    // References
    this.references = {
      play: this.playListener.bind(this),
      loadstart: this.autoplayListener.bind(this),
      pause: this.pauseListener.bind(this),
      playing: this.playingListener.bind(this),
      seeking: this.seekingListener.bind(this),
      seeked: this.seekedListener.bind(this),
      ended: this.endedListener.bind(this),
      timeupdate: this.timeupdateListener.bind(this)
    }

    this.referencesPlayer = {
      error: this.errorListener.bind(this)
    }

    // Register listeners
    this.registerTag()
    for (var key2 in this.referencesPlayer) {
      this.player.addEventListener(key2, this.referencesPlayer[key2])
    }
  },

  registerTag: function () {
    this.tag = this.player.getMediaElement ? this.player.getMediaElement() : this.player.a
    if (this.tag) {
      for (var key in this.references) {
        this.tag.addEventListener(key, this.references[key])
      }
    } else {
      setTimeout(this.registerTag.bind(this), 50)
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.tag && this.references) {
      for (var key in this.references) {
        this.tag.removeEventListener(key, this.references[key])
      }
      delete this.references
    }

    if (this.player && this.referencesPlayer) {
      for (var key2 in this.referencesPlayer) {
        this.player.removeEventListener(key2, this.referencesPlayer[key2])
      }
      delete this.referencesPlayer
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    if (this.getResource() && !this.flags.isStarted) {
      this.fireStart()
      this.initialPlayhead = this.getPlayhead()
    }
  },

  /** Listener for 'play' event. */
  autoplayListener: function (e) {
    if (this.tag.autoplay && !this.flags.isStarted) {
      this.fireStart()
      this.initialPlayhead = this.getPlayhead()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireResume()
    if (!this.flags.isStarted) {
      this.fireStart()
      this.initialPlayhead = this.getPlayhead()
    }
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    var msg = 'unknown'
    // Error codes: https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
    if (e.category && e.category < 10 && e.category > 0) {
      var typeDicc = {
        1: 'network',
        2: 'text',
        3: 'media',
        4: 'manifest',
        5: 'streaming',
        6: 'drm',
        7: 'player',
        8: 'cast',
        9: 'storage'
      }
      msg = typeDicc[e.category]
    }
    if (e.detail && e.detail.code) {
      this.fireError(e.detail.code, msg)
    } else {
      this.fireError(e.code, msg)
    }
    if ((e.code && (e.code === 1002 || e.code === 3016)) ||
      (e.detail && e.detail.code && (e.detail.code === 1002 || e.detail.code === 3016))) return
    if ((e.severity && e.severity === 2) || (e.detail.severity && e.detail.severity === 2)) { // Critical
      this.fireStop()
    }
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    if (this.flags.isBuffering) {
      this.fireBufferEnd()
    }
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  timeupdateListener: function (e) {
    if (!this.flags.isStarted) {
      this.fireStart()
      this.initialPlayhead = this.getPlayhead()
    }
    if (this.getPlayhead() > this.initialPlayhead + 0.1) {
      this.fireJoin()
    }
  }
})

module.exports = youbora.adapters.Shaka
